module.exports = __webpack_public_path__ + "static/gradientOne-59869c9467fbca135968c58d7005597b.png";